"use strict";

var _slicedToArray = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useIMGElementState;
var _react = require("react");
var _reactNative = require("react-native");
var _defaultInitialImageDimensions = _interopRequireDefault(require("./defaultInitialImageDimensions"));
var _useIMGNormalizedSource = _interopRequireDefault(require("./useIMGNormalizedSource"));
var _useImageConcreteDimensions = _interopRequireDefault(require("./useImageConcreteDimensions"));
var _getIMGState = require("./getIMGState");
var _useImageSpecifiedDimensions = _interopRequireDefault(require("./useImageSpecifiedDimensions"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function getImageSizeAsync(_ref) {
  var uri = _ref.uri,
    headers = _ref.headers;
  return new Promise(function (onsuccess, onerror) {
    var onImageDimensionsSuccess = function onImageDimensionsSuccess(width, height) {
      return onsuccess({
        width: width,
        height: height
      });
    };
    if (headers) {
      _reactNative.Image.getSizeWithHeaders(uri, headers, onImageDimensionsSuccess, onerror);
    } else {
      _reactNative.Image.getSize(uri, onImageDimensionsSuccess, onerror);
    }
  });
}
function useImageNaturalDimensions(props) {
  var source = props.source,
    cachedNaturalDimensions = props.cachedNaturalDimensions;
  var _ref2 = (0, _react.useState)(cachedNaturalDimensions || null),
    _ref3 = _slicedToArray(_ref2, 2),
    naturalDimensions = _ref3[0],
    setNaturalDimensions = _ref3[1];
  var _ref4 = cachedNaturalDimensions || {},
    cachedNaturalWidth = _ref4.width,
    cachedNaturalHeight = _ref4.height;
  var _ref5 = (0, _react.useState)(null),
    _ref6 = _slicedToArray(_ref5, 2),
    error = _ref6[0],
    setError = _ref6[1];
  (0, _react.useEffect)(function resetOnURIChange() {
    setNaturalDimensions(cachedNaturalWidth != null && cachedNaturalHeight != null ? {
      width: cachedNaturalWidth,
      height: cachedNaturalHeight
    } : null);
    setError(null);
  }, [cachedNaturalHeight, cachedNaturalWidth, source.uri]);
  return {
    onNaturalDimensions: setNaturalDimensions,
    onError: setError,
    naturalDimensions: naturalDimensions,
    error: error
  };
}
function useFetchedNaturalDimensions(props) {
  var source = props.source,
    cachedNaturalDimensions = props.cachedNaturalDimensions;
  var _useImageNaturalDimen = useImageNaturalDimensions(props),
    error = _useImageNaturalDimen.error,
    naturalDimensions = _useImageNaturalDimen.naturalDimensions,
    onError = _useImageNaturalDimen.onError,
    onNaturalDimensions = _useImageNaturalDimen.onNaturalDimensions;
  var hasCachedDimensions = !!cachedNaturalDimensions;
  (0, _react.useEffect)(function fetchPhysicalDimensions() {
    var cancelled = false;
    if (source.uri && !hasCachedDimensions) {
      getImageSizeAsync({
        uri: source.uri,
        headers: source.headers
      }).then(function (dimensions) {
        return !cancelled && onNaturalDimensions(dimensions);
      }).catch(function (e) {
        return !cancelled && onError(e || {});
      });
      return function () {
        cancelled = true;
      };
    }
  }, [source.uri, source.headers, onNaturalDimensions, onError, hasCachedDimensions]);
  return {
    naturalDimensions: naturalDimensions,
    error: error,
    onError: onError,
    onNaturalDimensions: onNaturalDimensions
  };
}
/**
 * This hook will compute concrete dimensions from image natural dimensions and
 * constraints. It will fetch the image and get its dimensions.
 *
 * @remarks If you know the dimensions beforehand, use
 * {@link useIMGElementStateWithCache} instead to save a network request and
 * prevent a layout shift.
 */

function useIMGElementState(props) {
  var alt = props.alt,
    altColor = props.altColor,
    source = props.source,
    contentWidth = props.contentWidth,
    computeMaxWidth = props.computeMaxWidth,
    objectFit = props.objectFit,
    _props$initialDimensi = props.initialDimensions,
    initialDimensions = _props$initialDimensi === void 0 ? _defaultInitialImageDimensions.default : _props$initialDimensi,
    cachedNaturalDimensions = props.cachedNaturalDimensions;
  var _ref7 = (0, _useImageSpecifiedDimensions.default)(props),
    flatStyle = _ref7.flatStyle,
    specifiedDimensions = _ref7.specifiedDimensions;
  var nomalizedSource = (0, _useIMGNormalizedSource.default)({
    specifiedDimensions: specifiedDimensions,
    source: source
  });
  var _useFetchedNaturalDim = useFetchedNaturalDimensions({
      source: nomalizedSource,
      specifiedDimensions: specifiedDimensions,
      cachedNaturalDimensions: cachedNaturalDimensions
    }),
    naturalDimensions = _useFetchedNaturalDim.naturalDimensions,
    onError = _useFetchedNaturalDim.onError,
    error = _useFetchedNaturalDim.error;
  var concreteDimensions = (0, _useImageConcreteDimensions.default)({
    flatStyle: flatStyle,
    naturalDimensions: naturalDimensions,
    specifiedDimensions: specifiedDimensions,
    computeMaxWidth: computeMaxWidth,
    contentWidth: contentWidth
  });
  return (0, _getIMGState.getIMGState)({
    error: error,
    alt: alt,
    altColor: altColor,
    concreteDimensions: concreteDimensions,
    containerStyle: flatStyle,
    initialDimensions: initialDimensions,
    objectFit: objectFit,
    onError: onError,
    source: nomalizedSource
  });
}